import http from '@root/utils/axios/admin';

let state = {
    GamesList: [],
    Game: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchGamesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/games', { params: filter }).then((response) => {
                commit('setGamesList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteGame({ commit }, id) {
        return http.delete('user/games/' + id);
    },

    fetchGame({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('user/games/' + id).then((response) => {
                commit('setGame', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateGame({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/games', data).then((response) => {
                commit('setGame', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGameError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateGame({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/games/' + data.get('id'), data).then((response) => {
                commit('setGame', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGameError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setGamesList(state, data) {
        state.GamesList = data;
    },
    setGame(state, data) {
        state.Game.data = data;
    },
    setGameError(state, error) {

        state.Game.error = error.errors;
    },
    cleanGameError(state, error) {
        state.Game.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}